import React, { useContext, useRef } from 'react';
import { ProfileContext } from '../../contexts/ProfileContext';
import Divider from '../Divider';

const BACKEND_HOST = process.env.REACT_APP_API_HOST;

const ObservationsTab = ({ orderNumber, order, orderDjango, agency, observationsOrder }) => {
  const { profile } = useContext(ProfileContext);
  const ref = useRef();

  const getDomicilio = () => {
    const { calle, colonia, ciudad } = order;
    let domicilio = '';
    if (calle) domicilio = domicilio.concat(calle);
    if (calle && (colonia || ciudad)) domicilio = domicilio.concat(', ');
    if (colonia) domicilio = domicilio.concat(colonia);
    if (colonia && ciudad) domicilio = domicilio.concat(', ');
    if (ciudad) domicilio = domicilio.concat(ciudad);
    return domicilio;
  };

  const ReportLink = () => {
    if (profile.user) {
      return (
        <button
          className="button is-primary is-medium has-text-weight-semibold"
          onClick={() => window.open(`${BACKEND_HOST}reports/order_media_report/${orderDjango.order_number}/${profile.user.id}/`, '_blank')}
        >
          <span className="icon mr-2">
            <i className="fas fa-file-pdf"></i>
          </span>
          <span>Generar PDF</span>
        </button>
      );
    } else {
      return null;
    }
  };

  // Helper para formatear fecha de observación
  const formatObservationDate = (fechaHora) => {
    try {
      const date = new Date(fechaHora);
      return {
        date: date.toLocaleDateString('es-ES'),
        time: date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
      };
    } catch (error) {
      return { date: fechaHora, time: '' };
    }
  };

  return (
    <div>
      {/* Header con Botón de PDF */}
      <div className="box has-background-white-ter" style={{ margin: 0 }}>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div>
                <h2 className="title is-5 mb-3">
                  <span className="icon mr-2 has-text-primary">
                    <i className="fas fa-eye"></i>
                  </span>
                  Observaciones de la Orden
                </h2>
                <p className="subtitle is-6 has-text-grey mb-0">
                  Historial de observaciones y notas del proceso
                </p>
              </div>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              {ReportLink()}
            </div>
          </div>
        </div>
      </div>

      <div ref={ref} id="observationTab">
        {/* Información Básica de la Orden */}
        <div className="card mb-4">
          <header className="card-header">
            <p className="card-header-title">
              <span className="icon mr-2">
                <i className="fas fa-clipboard-list"></i>
              </span>
              Datos de la Orden
            </p>
          </header>
          <div className="card-content">
            <div className="columns is-multiline">
              {/* Número de Orden */}
              <div className="column is-half-tablet is-one-third-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-hashtag"></i>
                      </span>
                      <span>Número de Orden</span>
                    </span>
                  </label>
                  <div className="field is-grouped">
                    <div className="control is-expanded">
                      <input
                        className="input has-text-centered has-text-weight-semibold"
                        type="text"
                        disabled={true}
                        value={orderNumber[0]}
                      />
                    </div>
                    <div className="control">
                      <span className="button is-static">-</span>
                    </div>
                    <div className="control is-expanded">
                      <input
                        className="input has-text-centered has-text-weight-semibold"
                        type="text"
                        disabled={true}
                        value={orderNumber[1]}
                      />
                    </div>
                    <div className="control">
                      <span className="button is-static">-</span>
                    </div>
                    <div className="control is-expanded">
                      <input
                        className="input has-text-centered has-text-weight-semibold"
                        type="text"
                        disabled={true}
                        value={orderNumber[2]}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Fecha de Alta */}
              <div className="column is-half-tablet is-one-third-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-calendar-plus"></i>
                      </span>
                      <span>Fecha de Alta</span>
                    </span>
                  </label>
                  <div className="control">
                    <input
                      className="input has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={orderDjango.order_date}
                    />
                  </div>
                </div>
              </div>

              {/* Agencia */}
              <div className="column is-half-tablet is-one-third-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-building"></i>
                      </span>
                      <span>Agencia</span>
                    </span>
                  </label>
                  <div className="control">
                    <input
                      className="input has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={agency}
                    />
                  </div>
                </div>
              </div>

              {/* Vigencia de Orden */}
              <div className="column is-full-tablet is-two-thirds-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-calendar-check"></i>
                      </span>
                      <span>Vigencia de la Orden</span>
                    </span>
                  </label>
                  <div className="field is-grouped">
                    <div className="control is-expanded">
                      <input
                        className="input has-text-weight-semibold"
                        readOnly
                        disabled
                        type="text"
                        placeholder="Fecha desde"
                        value={orderDjango.valid_from}
                      />
                    </div>
                    <div className="control">
                      <span className="button is-static is-primary is-light">
                        <span className="icon">
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </span>
                    </div>
                    <div className="control is-expanded">
                      <input
                        className="input has-text-weight-semibold"
                        readOnly
                        disabled
                        type="text"
                        placeholder="Fecha hasta"
                        value={orderDjango.valid_until}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Anunciante */}
              <div className="column is-full">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-bullhorn"></i>
                      </span>
                      <span>Anunciante</span>
                    </span>
                  </label>
                  <div className="control">
                    <input
                      className="input has-text-weight-semibold"
                      readOnly
                      disabled
                      type="text"
                      value={order['Anunciante']}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabla de Observaciones */}
        <div className="card mb-4">
          <header className="card-header">
            <p className="card-header-title">
              <span className="icon mr-2">
                <i className="fas fa-comment-alt"></i>
              </span>
              Historial de Observaciones
              <span className="tag is-light ml-2">
                {observationsOrder.length} observación{observationsOrder.length !== 1 ? 'es' : ''}
              </span>
            </p>
          </header>
          <div className="card-content p-0">
            {observationsOrder.length === 0 ? (
              <div className="has-text-centered py-6">
                <span className="icon-text has-text-grey">
                  <span className="icon is-large mr-3">
                    <i className="fas fa-comment-slash fa-2x"></i>
                  </span>
                  <span className="is-size-5">No hay observaciones registradas</span>
                </span>
                <p className="has-text-grey mt-2">
                  Las observaciones del proceso aparecerán aquí
                </p>
              </div>
            ) : (
              <div className="table-container">
                <table className="table is-bordered is-striped is-hoverable is-fullwidth mb-0">
                  <thead>
                    <tr className="has-background-primary">
                      <th className="has-text-white">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-calendar-alt"></i>
                          </span>
                          <span>Fecha</span>
                        </span>
                      </th>
                      <th className="has-text-white">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-clock"></i>
                          </span>
                          <span>Hora</span>
                        </span>
                      </th>
                      <th className="has-text-white">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-broadcast-tower"></i>
                          </span>
                          <span>Medio</span>
                        </span>
                      </th>
                      <th className="has-text-white">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-align-left"></i>
                          </span>
                          <span>Descripción</span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {observationsOrder.map((observation, index) => {
                      const { date, time } = formatObservationDate(observation.fecha_hora);
                      return (
                        <tr key={index} className="is-size-6">
                          <td className="has-text-weight-semibold">
                            <span className="icon-text">
                              <span className="icon is-small mr-2 has-text-primary">
                                <i className="fas fa-calendar"></i>
                              </span>
                              <span>{date}</span>
                            </span>
                          </td>
                          <td className="has-text-weight-semibold">
                            {time && (
                              <span className="tag is-light is-medium">
                                <span className="icon is-small mr-1">
                                  <i className="fas fa-clock"></i>
                                </span>
                                <span>{time}</span>
                              </span>
                            )}
                          </td>
                          <td>
                            <span className="tag is-info is-light is-medium">
                              <span className="icon is-small mr-1">
                                <i className="fas fa-broadcast-tower"></i>
                              </span>
                              <span>{observation.desc_medio}</span>
                            </span>
                          </td>
                          <td className="has-text-weight-semibold">
                            <div className="content is-small">
                              <p className="mb-0 is-size-6">{observation.observacion}</p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObservationsTab;